import React from 'react';
import { translate } from '../../../../../Services/translation';
import { cn } from '../../../../../Utils/cn';

const CheckoutCartSummary = ({ checkout, cart }) => {
  const { payload } = checkout || {};
  const { isBusinessCustomer } = payload || {};

  const deliveryCost = {
    label: 'checkout.order.deliverycost',
    value: cart.deliveryCost,
  };
  const paymentCost = {
    label: 'checkout.order.paymentcost',
    value: cart.paymentCost,
  };
  const discount = {
    label: 'checkout.order.discount',
    value: cart.discount,
  };

  let list = [];

  if (isBusinessCustomer) {
    list = [
      deliveryCost,
      paymentCost,
      discount,
      {
        label: 'checkout.order.grandtotalbusiness',
        value: cart.grandTotalWithoutVat,
        emphasized: true,
      },
    ];
  } else {
    list = [
      {
        label: 'checkout.order.totalnovat',
        value: cart.orderTotalWithoutVat,
      },
      {
        label: 'checkout.order.vat',
        value: cart.vat,
      },
      deliveryCost,
      paymentCost,
      discount,
      {
        label: 'checkout.order.grandTotal',
        value: cart.grandTotal,
        emphasized: true,
      },
    ];
  }

  list = list.filter(({ value }) => {
    if (!value) {
      return false;
    }
    const cleaned = value.replace(/[^\d.,-]/g, '');
    const normalized = cleaned.replace(',', '.');
    const number = parseFloat(normalized);
    return !isNaN(number) && number !== 0;
  });

  if (!list?.length) {
    return null;
  }

  return (
    <ul className="body bg-input-primary -mx-4 -mb-6 rounded-b-2xl p-6 md:-mx-6 md:-mb-8">
      {list.map(({ label, value, emphasized }, index) => (
        <li
          className={cn(
            'flex justify-between gap-4',
            emphasized && 'text-[1.25em] font-extrabold'
          )}
          key={`${label}${index}`}
        >
          <span>{translate(label)}</span>
          <span className="text-right">{value}</span>
        </li>
      ))}
    </ul>
  );
};

export default CheckoutCartSummary;
